import React, { useState } from 'react';

const Add = () => {
  const [permissions, setPermissions] = useState({
    selectAll: false,
    modules: {
      Masters: { Listing: false, add: false, edit: false, delete: false, view: false },
      Admin: { Listing: false, add: false, edit: false, delete: false, view: false },
      Products: { Listing: false, add: false, edit: false, delete: false, view: false },
      Corporates: { Listing: false, add: false, edit: false, delete: false, view: false },
      Users: { Listing: false, add: false, edit: false, delete: false, view: false },
      Excel: {Listing: false, add: false, edit: false, delete: false, view: false },
      Email: { Listing: false, add: false, edit: false, delete: false, view: false },
  },
  });
  const formattedPermissions = Object.keys(permissions.modules).map((module) => ({
    
    module_name: module.toLowerCase(), // Convert to lowercase as per the example
    name: module, // Retaining original module name
    create: permissions.modules[module].add, // Mapping 'add' to 'create'
    edit: permissions.modules[module].edit,
    listing: permissions.modules[module].Listing, // Mapping 'Listing' to 'listing'
    view: permissions.modules[module].view,
  }));
  
  console.log("Formatted Permissions:", formattedPermissions);
  
  const handleModuleChange = (module, permission) => {
    setPermissions((prev) => ({
      ...prev,
      modules: {
        ...prev.modules,
        [module]: {
          ...prev.modules[module],
          [permission]: !prev.modules[module][permission],
        },
      },
    }));
  };

  const handleSelectAll = (module) => {
    console.log("Moduleeees", module)
    setPermissions((prev) => {
      const newState = !Object.values(prev.modules[module]).every(Boolean);
      return {
        ...prev,
        modules: {
          ...prev.modules,
          [module]: {
            add: newState,
            edit: newState,
            delete: newState,
            view: newState,
          },
        },
      };
    });
  };

  const handleGlobalSelectAll = () => {
    setPermissions((prev) => {
      const newState = !prev.selectAll;
      const updatedModules = Object.keys(prev.modules).reduce((acc, module) => {
        acc[module] = { add: newState, edit: newState, delete: newState, view: newState };
        return acc;
      }, {});
      return {
        selectAll: newState,
        modules: updatedModules,
      };
    });
  };

  return (
    <div className='container-fluid'>
    <div className='row'>
      <div className='col-sm-12'>
        <div className='card'>
          <div className="portlet-body mx-3">
      <h3>
        <input
          type='checkbox'
          checked={permissions.selectAll}
          onChange={handleGlobalSelectAll}
        />
        Permissions
      </h3>
      <hr/>
      {Object.keys(permissions.modules).map((module) => (
        <div key={module}>
          <h5>
            <input
              type='checkbox'
              checked={Object.values(permissions.modules[module]).every(Boolean)}
              onChange={() => handleSelectAll(module)}
            />
            {module}
          </h5>
          <div style={{ display: 'flex', gap: '15px' }}>
            {Object.keys(permissions.modules[module]).map((perm) => (
              <label key={perm} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <input
                  type='checkbox'
                  checked={permissions.modules[module][perm]}
                  onChange={() => handleModuleChange(module, perm)}
                />
                {perm.charAt(0).toUpperCase() + perm.slice(1)}
              </label>
            ))}
          </div>
          <hr style={{
  border: "none",
  height: "2px",
  backgroundColor: "#ccc",  // Use backgroundColor for React
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",  // Box shadow for soft blur effect
  filter: "blur(1px)",  // Light blur effect
  margin: "20px 0"
}} />
</div>
      ))}
    </div>
    </div>
    </div>
</div>
</div>
  );
};

export default Add;
